// extracted by mini-css-extract-plugin
export default {"container":"CreateEstimateFieldsTab_container__mO+Mn","label":"CreateEstimateFieldsTab_label__2raNI","formFooter":"CreateEstimateFieldsTab_formFooter__msUEs"};